import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const updateRecords = async (
  projectIds,
  recordsToUpdateIds,
  updateAttributes,
  activeEmployerInfo
) => {
  const apiPath = `records/editRecords`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { projectIds, recordsToUpdateIds, updateAttributes },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
